import { defineStore } from 'pinia'
import apiService from '@/services/axios'

export const useAuthStore = defineStore({
  id: 'auth',
  state: () => ({
    user: null,
    accessToken: localStorage.getItem('accessToken') || '',
    refreshToken: localStorage.getItem('refreshToken') || '',
    returnUrl: '',
  }),
  actions: {
    async login(data: { username: string; password: string; isRememberMe: boolean }) {
      return await apiService
        .post('authen/login', data)
        .then((response: any) => {
          this.accessToken = response.data.result.accessToken
          this.refreshToken = response.data.result.refreshToken
          localStorage.setItem('accessToken', response.data.result.accessToken)
          localStorage.setItem('refreshToken', response.data.result.refreshToken)
        })
        .catch((err: any) => {
          throw err
        })
    },
    async logout() {
      this.accessToken = ''
      this.refreshToken = ''
      localStorage.removeItem('accessToken')
      localStorage.removeItem('refreshToken')
    },
    async refresh() {
      return await apiService
        .post('authen/refresh-token')
        .then((response) => {
          this.accessToken = response.data.result.accessToken
          this.refreshToken = response.data.result.refreshToken
          localStorage.setItem('accessToken', response.data.result.accessToken)
          localStorage.setItem('refreshToken', response.data.result.refreshToken)
        })
        .catch(() => {
          this.logout()
        })
    },
    async profile() {
      return await apiService
        .get('authen/profile')
        .then((response) => {
          this.user = response.data.data || null
        })
        .catch((err) => {
          console.log('Can not get profile', err)
          this.logout()
        })
    },
    async forgotPassword(username: string) {
      return await apiService.post('authen/forgot-password', { username })
    },
    async resetPassword(data: { username: string; token: string; newPassword: string; confirmNewPassword: string }) {
      return await apiService.post('authen/reset-password', data)
    },
  },
})
